import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const LinkIcon = ({ size, color, deg }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", size: size, color: color, deg: deg },
    React.createElement("path", { fillRule: "evenodd", d: "M11.273 3H17v5.727h-1.273v-3.54l-7.795 7.836-.955-.955 7.835-7.795h-3.54V3zM3 5.545h8.273L10 6.818H4.273v8.91h8.909V10l1.273-1.273V17H3V5.545z" })));
export const Link = iconGenerator(LinkIcon);
//# sourceMappingURL=Link.js.map